import { createActions, createReducer } from "reduxsauce";

//Action types e Creators
export const { Types, Creators } = createActions({
	setLoadingConciliationReport: []
});

//Reducer Handlers
const INITIAL_STATE = {
	isLoadingConciliationReport: false
}

const setLoadingConciliationReport = (state = INITIAL_STATE, action) => {
	return {...state, isLoadingConciliationReport: action.payload }
}

//Criando Reducer
export default createReducer(INITIAL_STATE, {
	[Types.SET_LOADING_CONCILIATION_REPORT] : setLoadingConciliationReport,
});
